<div>
  <glxy-form-field class="notes-area">
    <textarea
      matInput
      matTextareaAutosize
      [(ngModel)]="note"
      #opportunityNotes
      voiceTextArea
      [htmlTextAreaElement]="opportunityNotes"
    ></textarea>
  </glxy-form-field>
  <div class="notes-actions">
    <button mat-stroked-button color="secondary" (click)="handleCancel($event)">
      {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="handleSave($event)">
      {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
    </button>
  </div>
</div>
